export default function HEXtoRGB(hex: string) {
  const strippedHex = hex.replace('#', '');
  const bigint = parseInt(strippedHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
}
